import * as editChecks from '../../../constants/injurySummaryEditConstants.js';
import * as errorMessages from '../../../constants/errorMessages';

export default function confirmFormIsValid(injurySummary, requiredFields, activeFields) {
  let formIsValid = true;
  let errors = {};
  let softErrors = {};
  requiredFields.map(questionPart => {
    let fieldName = questionPart.questionPartName;
    let label = questionPart.questionPartLabel;
    //if field is empty, set the empty value error message
    if (!injurySummary[fieldName] && injurySummary[fieldName] !== 0) {
      formIsValid = false;
      if(activeFields.indexOf(fieldName) !== -1 &&
        (fieldName==="totalDeaths" || fieldName==="totalDafwCases"
          || fieldName==="totalDjtrCases" || fieldName=== "totalOtherCases")){
        errors[fieldName] = ((fieldName == "noInjuries")
            ? "This field"
            : "Number of " + label.slice(0, label.indexOf("(")))
              + errorMessages.ERROR_NEEDS_VALUE;
      }
      else if (activeFields.indexOf(fieldName) !== -1 &&
        (fieldName === "annualAverageEmployees" || fieldName === "totalHoursWorked")) {
          errors[fieldName] = ((fieldName == "noInjuries")
            ? "This field"
            : label) + errorMessages.ERROR_NEEDS_VALUE;
      }
      else if (activeFields.indexOf(fieldName) !== -1) {
        errors[fieldName] = ((fieldName == "noInjuries")
            ? "This field"
            : "Total Number of " + label.slice(0, label.indexOf("(")))
              + errorMessages.ERROR_NEEDS_VALUE;
      }
    } else if (injurySummary[fieldName] &&
      (fieldName === "annualAverageEmployees" || fieldName === "totalHoursWorked")) {
      //ensure that only numbers are entered
      if (activeFields.indexOf(fieldName) !== -1) {
        let message = checkForAlphaAndAboveZero(injurySummary[fieldName]);
        if (message === 'failed: alphabetic') {
          formIsValid = false;

          errors[fieldName] = ((fieldName == "noInjuries")
              ? "This field"
              : label) + errorMessages.ERROR_INJURY_SUMMARY_ALPHA;
        } else if (message === 'failed: not above zero') {
          formIsValid = false;
          errors[fieldName] = ((fieldName == "noInjuries")
              ? "This field"
              : label) + errorMessages.ERROR_INJURY_SUMMARY_NO_ZERO;
        }
      }
    }
    else if (injurySummary[fieldName]) {
      //no letters or negative numbers in fields
      if (activeFields.indexOf(fieldName) !== -1) {
        let message = checkForAlphaAndPositive(injurySummary[fieldName]);
        if(fieldName==="totalDeaths" || fieldName==="totalDafwCases"
          || fieldName==="totalDjtrCases" || fieldName=== "totalOtherCases") {
          if (message === 'failed: alphabetic') {
            formIsValid = false;

            errors[fieldName] = ((fieldName == "noInjuries")
                ? "This field"
                : "Number of " + label.slice(0, label.indexOf("(")))
                  + errorMessages.ERROR_INJURY_SUMMARY_ALPHA;
          } else if (message === 'failed: not above zero') {
            formIsValid = false;
            errors[fieldName] = ((fieldName == "noInjuries")
                ? "This field"
                : "Number of " + label.slice(0, label.indexOf("(")))
                  + errorMessages.ERROR_INJURY_NEGATIVE;
          }
        }
        else {
          if (message === 'failed: alphabetic') {

            formIsValid = false;

            errors[fieldName] = ((fieldName == "noInjuries")
              ? "This field"
              : "Total Number of " + label.slice(0, label.indexOf("(")))
                  + errorMessages.ERROR_INJURY_SUMMARY_ALPHA;
          } else if (message === 'failed: not above zero') {
            formIsValid = false;
            errors[fieldName] = ((fieldName == "noInjuries")
                ? "This field"
                : "Total Number of " + label.slice(0, label.indexOf("(")))
                  + errorMessages.ERROR_INJURY_NEGATIVE;
          }
        }
      }
    }
  });
  const totalDafwDays = parseInt(injurySummary.totalDafwDays);
  const totalDafwCases = parseInt(injurySummary.totalDafwCases);
  const totalDjtrCases = parseInt(injurySummary.totalDjtrCases);
  const totalDjtrDays = parseInt(injurySummary.totalDjtrDays);
  const totalDeaths = parseInt(injurySummary.totalDeaths);

  // Summary: If there is a death, the user can enter dafwDays or djtrDays
  // even if the total dawf cases and total djtr cases are both 0
  if (totalDeaths > 0 && totalDafwCases === 0 && totalDjtrCases === 0) {
    // Don't validate on dafwDays or djtrDays
  }
  // Summary: If no deaths, and if dawf cases is 1+ then the user must
  // enter days away from work and may enter djtr days, even if djtr cases is 0
  else if (totalDeaths === 0 && totalDafwCases > 0) {
    // Must have dafw days. Don't validate for djtr days.
    if (totalDafwDays == 0) {
      formIsValid = false;
      errors.totalDafwCases = errorMessages.ERROR_CASES_DAYS_AWAY_MISMATCH_OPP;
    }
  }
  // Summary: If no deaths, and dafw cases is 0 and if djtr cases is 1+,
  // then the user must enter djtr days, and the dawf days must equal zero.
  else if (totalDeaths === 0 && totalDafwCases === 0 && totalDjtrCases > 0) {
    // Must have djtr days. Should not have dafw days.
    if (totalDjtrDays === 0) {
      formIsValid = false;
      errors.totalDjtrDays = errorMessages.ERROR_CASES_JOB_TRANSFER_MISMATCH_OPP;
    }
    if (totalDafwDays !== 0) {
      formIsValid = false;
      errors.totalDafwDays = errorMessages.ERROR_CASES_NO_DAFW_CASES_NO_DEATH;
    }
  }
  // Summary: If no deaths and no cases then dawf days and djtr days must be zero.
  else if (totalDeaths === 0 && totalDafwCases === 0 && totalDjtrCases === 0) {
    // Must have djtr days. Should not have dafw days.
    if (totalDjtrDays !== 0) {
      formIsValid = false;
      errors.totalDjtrDays = errorMessages.ERROR_CASES_NO_DJTR_CASES_NO_DEATH;
    }
    if (totalDafwDays !== 0) {
      formIsValid = false;
      errors.totalDafwDays = errorMessages.ERROR_CASES_NO_DAFW_CASES_NO_DEATH;
    }
  }
  if (totalDafwDays < totalDafwCases) {
    formIsValid = false;
    errors.totalDafwDays = errorMessages.DAYS_HIGHER_THAN_CASES;
  }

  //ensure group values add up to proper amounts
  let total = parseInt(injurySummary.totalOtherIllnesses)
    + parseInt(injurySummary.totalHearingLoss)
    + parseInt(injurySummary.totalPoisonings)
    + parseInt(injurySummary.totalRespiratoryConditions)
    + parseInt(injurySummary.totalSkinDisorders)
    + parseInt(injurySummary.totalInjuries);

  let casesTotal = parseInt(injurySummary.totalDeaths)
    + parseInt(injurySummary.totalDafwCases)
    + parseInt(injurySummary.totalDjtrCases)
    + parseInt(injurySummary.totalOtherCases);

  if (casesTotal != total && !isNaN(casesTotal) && !isNaN(total)) {
    formIsValid = false;

    errors.injuryAndIllnessTypes = errorMessages.ERROR_TOTALS_NOT_EQUAL;
    errors.numberOfCases = errorMessages.ERROR_TOTALS_NOT_EQUAL;
  }
  if (casesTotal > parseInt(injurySummary.annualAverageEmployees)) {
    softErrors.totalDafwCases = errorMessages.ERROR_CASES_GREATER_EMP;

  }
  if (injurySummary.annualAverageEmployees > editChecks.ANNUAL_AVG_LIMIT) {
    softErrors.annualAverageEmployees = errorMessages.WARNING_AVG_EMPLOYEES;
  }
  if (injurySummary.totalHoursWorked / injurySummary.annualAverageEmployees
    > editChecks.EMPLOYEE_TO_HOUR_RATIO) {
    softErrors.totalHoursWorked = errorMessages.WARNING_EMPLOYEE_TO_HOUR_RATIO;
  }

  if (injurySummary.totalHoursWorked / injurySummary.annualAverageEmployees
    < editChecks.EMPLOYEE_TO_HOUR_LOW_RATIO) {
    softErrors.totalHoursWorked = errorMessages.WARNING_EMPLOYEE_RATIO_TOO_LOW;
  }

  return {formIsValid, errors, softErrors};
}

function checkForAlphaAndPositive(field) {
  let message = '';
  if (!editChecks.REG_EX_NUMERIC.test(field)) {
    message = 'failed: alphabetic';
  }
  if (field < 0) {
    message = 'failed: not above zero';
  }
  return message;
}

function checkForAlphaAndAboveZero(field) {
  let message = '';
  if (!editChecks.REG_EX_NUMERIC.test(field)) {
    message = 'failed: alphabetic';
  }
  if (field <= 0) {
    message = 'failed: not above zero';
  }
  return message;
}



/** WEBPACK FOOTER **
 ** ./src/components/injurySummary/InjurySummaryManagement/InjurySummaryEditChecks.js
 **/